export const canNavigateBack = (): boolean =>
  typeof window.history.state?.idx === 'number' && window.history.state.idx > 0;
